import ComplicationSelector from "@ls/grouping-complication-selector";
import { useDispatch, useSelector } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "state/scenarioAnalysis/selectors";
import { useCallback } from "react";
import ScenarioAnalysisDefinition from "state/scenarioAnalysis/ScenarioAnalysisDefinition";
import { setDefinition as setScenarioAnalysisDefinition } from "state/scenarioAnalysis/actions";
import ScenarioAnalysisComplication from "./ScenarioAnalysisSelectorComplication";
const ScenarioAnalysisSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (idx, definition) =>
      dispatch(setScenarioAnalysisDefinition(idx, definition)),
    [dispatch]
  );
  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={ScenarioAnalysisDefinition.getDefault}
      ComplicationComponent={ScenarioAnalysisComplication}
      btnTitle={"Scenario Analysis"}
      addMoreText={"Scenario Analysis Column"}
    />
  );
};
export default ScenarioAnalysisSelector;
